import React from "react";
import {
  Chip,
  Button,
  Card,
  CardContent,
  CardHeader,
  TableContainer,
  Paper,
} from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import CustomDatagrid from "../../../components/datagrid";
import moment from "moment";
import { useDispatch } from "react-redux";
import { showLoader, hideLoader } from "../../../redux/loader/actions";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import ordersApi from "../../../services/orders";
import subscriptionApi from "../../../services/subscription";
function OrdersList({
  subscriberData,
  rowCount,
  paginationModel,
  setPaginationModel,
  searchparams,
}) {
  const dispatch = useDispatch();

  const orcdersListRows = Array.isArray(subscriberData.data)
    ? subscriberData.data.map((data, index) => {
       
        return {
          cancel_id: data?.subscription_uuid,
          id: index + 1,
          sno_id: paginationModel.page * paginationModel.pageSize + index + 1,
          client_id: data?.userDetails?.client_id,
          name: data?.userDetails?.username,
          organisation: data?.userDetails?.organization_name,
          email: data?.userDetails?.email,
          mobile_number: data?.userDetails?.mobile_number,
          order_id:
            data?.paymentReceipt?.invoice?.invoiceSubscriptionOrder?.order_code,
          subscription_id: data?.subscription_code,
          invoice_number: data?.paymentReceipt?.invoice?.invoice_no,
          subscription_amt: data?.paymentReceipt?.amount,
          product_name: data?.productPlanDetails?.product?.name,
          subscription_plan: data?.productPlanDetails?.product_plan_name,
          subscribed_on: data?.start_date,
          renewal_type: data?.renewal_type,
          expiry: data?.expiry_date,
          transaction_id: data?.paymentReceipt?.transaction_id,
          transaction_mode: data?.paymentReceipt?.payment_mode,
          transaction_date: data?.paymentReceipt?.payment_date,
          status: data?.subscription_status,
          sub_status: data?.subscription_type,
          invoiceNumber: data?.paymentReceipt?.invoice?.invoice_no,
        };
      })
    : [];

  const capitalizeFirstLetter = (str) => {
    if (!str) return "";
    return str.charAt(0).toUpperCase() + str.slice(1);
  };

  const handlePdf = (id, invoiceNumber) => {
    subscriptionApi
      ?.getInvoice(id)
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const formattedInvoiceNumber = invoiceNumber
          .replace(/^TAGITS/, "TAGITSTORE")
          .replace(/\//g, "-");
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = `${formattedInvoiceNumber}.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      })
      .catch((error) => {
        console.error("Error downloading the PDF:", error);
      });
  };

  const columns = [
    {
      field: "sno_id",
      headerName: "S.No",
      width: 100,
      headerAlign: "left",
      align: "center",
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return <span>{params.value}</span>;
      },
    },
    {
      field: "client_id",
      headerName: "Client ID",
      width: 150,
      headerAlign: "left",
      align: "center",
      sortable: false,
      renderCell: (params) => {
        return <span>{params.value}</span>;
      },
      disableColumnMenu: true,
    },
    {
      field: "name",
      headerName: "Name",
      width: 150,
      headerAlign: "left",
      align: "center",
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => capitalizeFirstLetter(params.value),
    },
    {
      field: "organisation",
      headerName: "Organization/Group",
      width: 150,
      headerAlign: "left",
      align: "center",
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => capitalizeFirstLetter(params.value),
    },
    {
      field: "email",
      headerName: "Email",
      width: 250,
      headerAlign: "left",
      align: "center",
      sortable: false,
      renderCell: (params) => {
        return <span>{params.value}</span>;
      },
      disableColumnMenu: true,
    },
    {
      field: "mobile_number",
      headerName: "Mobile Number",
      width: 150,
      headerAlign: "left",
      align: "center",
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return <span>{params.value}</span>;
      },
    },
    {
      field: "order_id",
      headerName: "Order ID",
      width: 150,
      headerAlign: "left",
      align: "center",
      sortable: false,
      renderCell: (params) => {
        return <span>{params.value}</span>;
      },
      disableColumnMenu: true,
    },
    {
      field: "subscription_id",
      headerName: "Subscription ID",
      width: 150,
      headerAlign: "left",
      align: "center",
      sortable: false,
      renderCell: (params) => {
        return <span>{params.value}</span>;
      },
      disableColumnMenu: true,
    },
    {
      field: "invoice_number",
      headerName: "Invoice Number",
      width: 150,
      headerAlign: "left",
      align: "center",
      sortable: false,
      disableColumnMenu: true,

      renderCell: (params) => {
        if (params?.row?.sub_status !== "trial") {
          return (
            <span
              style={{
                cursor: "pointer",
                color: "red",
                textDecoration: "underline",
              }}
              onClick={() =>
                handlePdf(
                  params?.row?.cancel_id,
                  params?.row?.invoiceNumber,
                  params?.row?.name || "invoice"
                )
              }
            >
              {params.value}
            </span>
          );
        } else {
          return <span>{params.value}</span>;
        }
      },
    },

    {
      field: "subscription_amt",
      headerName: "Subscription Amount",
      width: 150,
      headerAlign: "left",
      align: "center",
      sortable: false,
      renderCell: (params) => {
        return <span>{params.value}</span>;
      },
      disableColumnMenu: true,
    },
    {
      field: "product_name",
      headerName: "Product Name",
      width: 150,
      headerAlign: "left",
      align: "center",
      sortable: false,
      renderCell: (params) => {
        return <span>{params.value}</span>;
      },
      disableColumnMenu: true,
    },
    {
      field: "subscription_plan",
      headerName: "Subscription Plan",
      width: 150,
      headerAlign: "left",
      align: "center",
      sortable: false,
      renderCell: (params) => {
        return <span>{params.value}</span>;
      },
      disableColumnMenu: true,
    },
    {
      field: "subscribed_on",
      headerName: "Subscribed/Renewed On",
      width: 150,
      headerAlign: "left",
      align: "center",
      sortable: false,
      disableColumnMenu: true,

      renderCell: (params) =>
        moment.utc(params.row.subscribed_on).endOf("day").format("DD/MM/YYYY"),
    },
    {
      field: "renewal_type",
      headerName: "Renewal Type",
      width: 150,
      headerAlign: "left",
      align: "center",
      sortable: false,
      renderCell: (params) => getRenewalLabel(params.value),
    },
    {
      field: "expiry",
      headerName: "Expiry",
      width: 150,
      headerAlign: "left",
      align: "center",
      disableColumnMenu: true,
      sortable: false,
      renderCell: (params) =>
        moment.utc(params.row.expiry).endOf("day").format("DD/MM/YYYY"),
    },
    {
      field: "transaction_mode",
      headerName: "Transaction Mode",
      width: 150,
      headerAlign: "left",
      align: "center",
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => capitalizeFirstLetter(params.value),
    },
    {
      field: "transaction_date",
      headerName: "Transaction Date",
      width: 150,
      headerAlign: "left",
      align: "center",
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) =>
        moment
          .utc(params.row.transaction_date)
          .endOf("day")
          .format("DD/MM/YYYY"),
    },
    {
      field: "status",
      headerName: "Status",
      width: 150,
      headerAlign: "left",
      align: "center",
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => getStatusLabel(params.value),
    },
  ];

  const getStatusLabel = (status) => {
    switch (status) {
      case "active":
        return (
          <Chip
            variant="outlined"
            size="small"
            label="Active"
            color="success"
          />
        );
      case "cancelled":
        return (
          <Chip
            variant="outlined"
            size="small"
            label="Cancelled"
            color="warning"
          />
        );
      case "expired":
        return (
          <Chip variant="outlined" size="small" label="Expired" color="error" />
        );
      default:
        return <Chip variant="outlined" size="small" label={status} />;
    }
  };
  const getRenewalLabel = (renewal) => {
    switch (renewal) {
      case "automatic":
        return (
          <Chip variant="outlined" size="small" label="Auto" color="success" />
        );
      case "manual":
        return (
          <Chip
            variant="outlined"
            size="small"
            label="Manual"
            color="warning"
          />
        );
      case "none":
        return (
          <Chip variant="outlined" size="small" label="None" color="error" />
        );
      default:
        return <Chip variant="outlined" size="small" label={renewal} />;
    }
  };

  const exportOrders = async () => {
    try {
      dispatch(showLoader());
      const response = await ordersApi?.orderExport(searchparams);
      if (response && response.data && response.data.body) {
        const base64File = response.data.body;
        const binaryString = atob(base64File);
        const binaryLen = binaryString.length;
        const buffer = new ArrayBuffer(binaryLen);
        const view = new Uint8Array(buffer);

        for (let i = 0; i < binaryLen; i++) {
          view[i] = binaryString.charCodeAt(i);
        }
        const workbook = XLSX.read(buffer, { type: "array" });
        const worksheet = workbook.Sheets[workbook.SheetNames[0]];
        const columnWidths = [
          { wpx: 50 },
          { wpx: 120 },
          { wpx: 180 },
          { wpx: 150 },
          { wpx: 200 },
          { wpx: 110 },
          { wpx: 150 },
          { wpx: 130 },
          { wpx: 180 },
          { wpx: 80 },
          { wpx: 150 },
          { wpx: 80 },
          { wpx: 120 },
          { wpx: 70 },
          { wpx: 120 },
          { wpx: 120 },
          { wpx: 120 },
          { wpx: 70 },
        ];
        worksheet["!cols"] = columnWidths;
        const range = XLSX.utils.decode_range(worksheet["!ref"]);
        for (let row = range.s.r; row <= range.e.r; row++) {
          for (let col = range.s.c; col <= range.e.c; col++) {
            const cellAddress = XLSX.utils.encode_cell({ r: row, c: col });
            const cell = worksheet[cellAddress];
            if (cell && cell.t === "n" && cell.v > 10000) {
              const excelDate = cell.v;
              const date = new Date((excelDate - 25569) * 86400 * 1000);
              const formattedDate = `${String(date.getDate()).padStart(
                2,
                "0"
              )}-${String(date.getMonth() + 1).padStart(
                2,
                "0"
              )}-${date.getFullYear()}`;
              cell.v = formattedDate;
              cell.t = "s";
            }
          }
        }

        const updatedBuffer = XLSX.write(workbook, {
          bookType: "xlsx",
          type: "array",
        });
        const blob = new Blob([updatedBuffer], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        saveAs(blob, "orders.xlsx");
      } else {
        throw new Error("Invalid response format");
      }
    } catch (error) {
      console.error("Error exporting orders:", error);
      alert("Failed to export orders.");
    } finally {
      dispatch(hideLoader());
    }
  };

  return (
    <Card elevation={6}>
      <CardHeader
        action={
          <Button
            aria-label="Export"
            startIcon={<FileDownloadIcon />}
            variant="outlined"
            size="small"
            onClick={exportOrders}
          >
            Export
          </Button>
        }
      />
      <CardContent>
        {orcdersListRows.length === 0 ? (
          <div
            style={{
              padding: "16px",
              textAlign: "center",
              color: "textSecondary",
              fontSize: "20px",
            }}
          >
            No data found
          </div>
        ) : (
          <TableContainer component={Paper} sx={{ overflowX: "auto" }}>
            <CustomDatagrid
              rows={orcdersListRows}
              columns={columns}
              getRowId={(row) => row.id}
              paginationModel={paginationModel}
              onPaginationModelChange={setPaginationModel}
              rowCount={rowCount}
              disableSelectionOnClick={true}
              checkboxSelection={false}
              pagination
              pageSizeOptions={[5, 10, 20]}
            />
          </TableContainer>
        )}
      </CardContent>
    </Card>
  );
}

export default OrdersList;
